/**
 * Mutu Buah API Service
 * Handles all API calls for fruit quality inspection module
 */

import api from '../../../auth/apiClient';
import { MutuBuahData, MutuBuahFilters, MutuBuahSummaryResponse } from '../types';
import { MUTU_BUAH_API_CONFIG, DEFAULT_CATEGORY_ID } from '../apiConfig';

export class MutuBuahApiService {
  /**
   * Fetch inspection details data
   * @param filters - Filter parameters (estate_id, division_id, inspection_date)
   * @returns Promise with inspection data array
   */
  static async getDetails(filters: MutuBuahFilters): Promise<MutuBuahSummaryResponse> {
    try {
      const params: Record<string, any> = {
        estate_id: filters.estate_id,
        division_id: filters.division_id,
        inspection_date: filters.inspection_date,
        category_id: filters.category_id || DEFAULT_CATEGORY_ID,
      };

      const response = await api.get(MUTU_BUAH_API_CONFIG.DETAILS, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching mutu buah details:', error);
      throw error;
    }
  }
}

export default MutuBuahApiService;
